import React from 'react';
export function PaymentMethodsSection() {
  return <></>;
}